<div *ngIf="visitorAnalytics" class="text-end mb-4">
  <p-selectButton [options]="stateOptions"
                  [ngModel]="stateValue" (ngModelChange)="onStateChange($event)"
                  optionLabel="label" optionValue="value" />
</div>

<div class="row filter-row filter-row align-items-end justify-content-end">
  <div class="col-sm form-group">
    <p>{{'COMMON.YEAR' | translate}}</p>
    <select class="form-select form-control" [(ngModel)]="selectedYear">
      <option *ngFor="let year of years" [value]="year">{{ year }}</option>
    </select>
  </div>
  <div class="col-sm form-group">
    <p>{{'COMMON.MONTH' | translate}}</p>
    <select class="form-select form-control" [(ngModel)]="selectedMonth">
      <option *ngFor="let month of months" [value]="month.value">{{ month.key | translate }}</option>
    </select>
  </div>
  <div class="col-sm form-group">
    <p>{{'COMMON.ORGANISATIONS' | translate}}</p>
    <select class="form-select form-control" [ngModel]="selectedOrganisation" [compareWith]="compareObjects"
            (ngModelChange)="onOrganisationChange($event)">
      <option *ngFor="let organisation of organisations" [ngValue]="organisation">{{ organisation.name | translate }}</option>
    </select>
  </div>
  <div class="col-sm form-group">
    <p>{{'COMMON.SITES' | translate}}</p>
    <select class="form-select form-control" [(ngModel)]="selectedSite.id">
      <option [value]="'ALL'">{{'COMMON.ALL' | translate}}</option>
      <option *ngFor="let site of sites" [value]="site.id">{{ site.name | translate }}</option>
    </select>
  </div>
  <div class="col-sm form-group">
    <button class="btn btn-primary" type="button" (click)="refreshDashboard()">
      {{'COMMON.UPDATE' | translate}}
    </button>
  </div>
</div>

<app-loaders *ngIf="isLoading"></app-loaders>

<ng-container *ngIf="!isLoading">
  <div class="mini-statistics d-flex flex-wrap gap-2 text-center mb-4">
    <div class="mini-card p-2">
      <p class="mb-1">{{'DASHBOARD.TOTAL_VISITOR_COUNT' | translate}}</p>
      <h3 class="mb-1">{{ dashboardSummary?.totalVisitor }}</h3>
      <p class="fw-bold mb-1" [ngClass]="dashboardSummary?.totalVisitorDiff >= 0 ? 'text-success' : 'text-danger'">
        <i class="mdi fs-6 me-1" [ngClass]="dashboardSummary?.totalVisitorDiff >= 0 ? 'mdi-trending-up' : 'mdi-trending-down'"></i>
        <span class="icon-span">{{ dashboardSummary.totalVisitorDiff }}</span>
      </p>
    </div>

    <div class="mini-card p-2">
      <p class="mb-1">{{'COMMON.AVERAGE_OCCUPANCY' | translate}}</p>
      <h3 class="mb-1">{{ dashboardSummary?.avgOccupancy| number:'1.2-2' }}</h3>
      <p class="fw-bold mb-1" [ngClass]="dashboardSummary?.avgOccupancyDiff >= 0 ? 'text-success' : 'text-danger'">
        <i class="mdi fs-6 me-1" [ngClass]="dashboardSummary?.avgOccupancyDiff >= 0 ? 'mdi-trending-up' : 'mdi-trending-down'"></i>
        <span class="icon-span">{{ dashboardSummary.avgOccupancyDiff| number:'1.2-2' }}</span>
      </p>
    </div>

    <div class="mini-card p-2">
      <p class="mb-1">{{'DASHBOARD.BUSIEST_HOUR' | translate}}</p>
      <h3 class="mb-1">{{ dashboardSummary?.busiestHour }}</h3>
      <p class="fw-bold text-secondary mb-1">{{ dashboardSummary.lastBusiestHour }}</p>
    </div>

    <div class="mini-card p-2">
      <p class="mb-1">{{'DASHBOARD.MOST_VISITED_HOUR' | translate}}</p>
      <h3 class="mb-1">{{ dashboardSummary?.mostVisitedHour }}</h3>
      <p class="fw-bold text-secondary mb-1">{{ dashboardSummary.lastMostVisitedHour }}</p>
    </div>

    <div class="mini-card p-2">
      <p class="mb-1">{{'DASHBOARD.MOST_VISITED_DAY' | translate}}</p>
      <h3 class="mb-1">{{ dashboardSummary?.mostVisitedDay }}</h3>
      <p class="fw-bold text-secondary mb-1">{{ dashboardSummary.lastMostVisitedDay }}</p>
    </div>
  </div>


  <div *ngIf="visitorAnalytics" class="mini-statistics d-flex flex-wrap gap-2 mb-4">
    <div class="mini-card d-flex align-items-center p-2">
      <i class="mdi mdi-account-outline fs-2 ms-1 me-2"></i>
      <span>
        <p class="mb-1">{{ 'DASHBOARD.' + (stateValue === 'visitors' ? 'UNIQUE_VISITORS' : 'VISITS') | translate }}</p>
        <h3 class="mb-0">{{ stateValue === 'visitors' ? visitorAnalytics.uniqueVisitors.count : visitorAnalytics.totalVisits.count }}</h3>
      </span>
    </div>

    <div class="mini-card d-flex align-items-center p-2">
      <i class="mdi mdi-autorenew fs-2 ms-1 me-2"></i>
      <span>
        <p class="mb-1">{{ 'COMMON.RETURNING_VISITORS' | translate: {visitorType: stateValue} }}</p>
        <h3 class="mb-0">{{ stateValue === 'visitors' ? visitorAnalytics.returningVisitors.count : visitorAnalytics.returningVisits.count }}</h3>
      </span>
    </div>

    <div class="mini-card d-flex align-items-center p-2">
      <i class="mdi mdi mdi-chart-bar fs-2 ms-1 me-2"></i>
      <span>
        <p class="mb-1">{{ 'DASHBOARD.RETURNING_VISITOR_RATE' | translate: {visitorType: stateValue} }}</p>
        <h3 class="mb-1">{{ stateValue === 'visitors' ? visitorAnalytics.returningVisitorRate.returningCount : visitorAnalytics.returningVisitRate.returningCount }}</h3>
        <p class="mb-0">
          {{ stateValue === 'visitors' ? visitorAnalytics.returningVisitorRate.percentage : visitorAnalytics.returningVisitRate.percentage }}%
          {{ 'DASHBOARD.OF_VISITORS' | translate: {visitorType: stateValue} }}
        </p>
      </span>
    </div>

    <div class="mini-card d-flex align-items-center p-2">
      <i class="mdi mdi-account-multiple fs-2 ms-1 me-2"></i>
      <span>
        <p class="mb-1">{{'DASHBOARD.DOMINANT_AGE_GROUP' | translate}}</p>
        <h3 class="mb-1">{{ visitorAnalytics.dominantAgeGroup?.label }}</h3>
        <p class="mb-0">
          {{ visitorAnalytics.dominantAgeGroup?.percentage }}% {{ 'DASHBOARD.OF_VISITORS' | translate: {visitorType: stateValue} }}
        </p>
      </span>
    </div>

    <div class="mini-card d-flex align-items-center p-2">
      <i class="mdi mdi-human-male-female fs-2 ms-1 me-2"></i>
      <span>
        <p class="mb-1">{{ 'DASHBOARD.ESTIMATED_GENDER' | translate: {visitorType: stateValue} }}</p>
        <h3 class="mb-1">
          {{ visitorAnalytics.estimatedGender.categories[1].percentage }}% / {{visitorAnalytics.estimatedGender.categories[0].percentage}}%
        </h3>
        <p class="mb-0">
          {{ visitorAnalytics.estimatedGender.categories[1].gender }} / {{visitorAnalytics.estimatedGender.categories[0].gender}}
        </p>
      </span>
    </div>

    <div class="mini-card d-flex align-items-center p-2">
      <i class="mdi mdi-shield-check-outline fs-2 ms-1 me-2"></i>
      <span>
        <p class="mb-1">{{'DASHBOARD.DEMOGRAPHIC_COVERAGE' | translate}}</p>
        <h3 class="mb-1">{{ visitorAnalytics.demographicCoverage.classifiedCount }} of {{ visitorAnalytics.demographicCoverage.populationCount }}</h3>
        <p class="mb-0">{{ visitorAnalytics.demographicCoverage.percentage}}% {{ 'DASHBOARD.OF_VISITORS' | translate: {visitorType: stateValue} }}</p>
      </span>
    </div>
  </div>


  <ng-container *ngIf="charts && charts.length > 0">
    <div *ngIf="visitorAnalytics" class="row mx-0">
      <div class="col-md-8 ps-0 mb-4">
        <div class="card stretch-card mb-2">
          <div class="card-body">
            <h4 class="card-title mb-3">{{'COMMON.AGE_GENDER_DISTRIBUTION' | translate }}</h4>
            <div class="chart-container" style="height: 250px; width: 100%;">
              <canvas baseChart
                      [type]="charts[5].type"
                      [data]="charts[5].data"
                      [options]="charts[5].options">
              </canvas>
            </div>
          </div>
        </div>

        <div class="card stretch-card">
          <div class="card-body">
            <h4 class="card-title mb-3">{{'COMMON.NEW_VS_RETURNING_VISITORS' | translate: {visitorType: stateValue} }}</h4>
            <div class="chart-container">
              <div class="progress mb-4 fw-bold text-white">
                <div class="progress-bar d-flex align-items-center justify-content-center"
                     role="progressbar"
                     [style.width.%]="charts[6].data.newVisitorsPercentage"
                     [style.backgroundColor]="colors.primary"
                     [attr.aria-valuenow]="charts[6].data.newVisitorsPercentage" aria-valuemin="0" aria-valuemax="100">
                  {{ charts[6].data.newVisitorsPercentage }}%
                </div>
                <div class="progress-bar d-flex align-items-center justify-content-center"
                     role="progressbar"
                     [style.width.%]="charts[6].data.returningVisitorsPercentage"
                     [style.backgroundColor]="colors.secondary"
                     [attr.aria-valuenow]="charts[6].data.returningVisitorsPercentage" aria-valuemin="0" aria-valuemax="100">
                  {{ charts[6].data.returningVisitorsPercentage }}%
                </div>
              </div>

              <div class="flex-grow-1 w-100">
                <div class="d-flex align-items-center mb-1">
                  <span class="rounded-circle me-3" [style.backgroundColor]="colors.primary"></span>
                  <span class="flex-grow-1">{{ 'COMMON.NEW_VISITORS' | translate: {visitorType: stateValue} }}</span>
                  <span class="fw-bold">{{ charts[6].legendData.newVisitors }}</span>
                </div>
                <div class="d-flex align-items-center mb-1">
                  <span class="rounded-circle me-3" [style.backgroundColor]="colors.secondary"></span>
                  <span class="flex-grow-1">{{ 'COMMON.RETURNING_VISITORS' | translate: {visitorType: stateValue} }}</span>
                  <span class="fw-bold">{{ charts[6].legendData.returningVisitors }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-4 pe-0 mb-4 stretch-card">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-3">{{'COMMON.GENDER_DISTRIBUTION' | translate: {visitorType: stateValue} }}</h4>
            <div class="chart-container">
              <div class="position-relative mb-3">
                <canvas baseChart
                        [type]="charts[7].type"
                        [data]="charts[7].data"
                        [options]="charts[7].options">
                </canvas>
                <div class="position-absolute top-50 start-50 translate-middle text-center w-100 pe-none">
                  <h3 class="mb-0 fw-bold fs-2">{{ charts[7].totalVisitors | number:'1.0-0' }}</h3>
                  <span class="text-muted small">{{'COMMON.ANALYZED_VISITORS' | translate: {visitorType: stateValue} }}</span>
                </div>
              </div>
              <div class="flex-grow-1 w-100">
                <div *ngFor="let item of charts[7].legendData" class="d-flex align-items-center mb-1">
                  <span class="rounded-circle me-3" [style.backgroundColor]="item.color"></span>
                  <span class="flex-grow-1">{{ item.label }}</span>
                  <span class="fw-bold">{{ item.percentage }}%</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row mx-0">
      <div class="col-md-6 ps-0 mb-4 stretch-card">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-3">{{'COMMON.AVERAGE_OCCUPANCY_IN_A_DAY' | translate }}</h4>
            <div class="chart-container">
              <canvas baseChart
                      [type]="charts[0].type"
                      [data]="charts[0].data"
                      [options]="dashboardChartConfig">
              </canvas>
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-6 pe-0 mb-4 stretch-card">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-3">{{'DASHBOARD.AVERAGE_VISITORS_IN_A_DAY' | translate }}</h4>
            <div class="chart-container">
              <canvas baseChart
                      [type]="charts[1].type"
                      [data]="charts[1].data"
                      [options]="dashboardChartConfig">
              </canvas>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col mb-4 stretch-card">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-3">{{'DASHBOARD.TOTAL_VISITORS_PER_MONTH' | translate }}</h4>
            <div class="chart-container">
              <canvas baseChart
                      [type]="charts[2].type"
                      [data]="charts[2].data"
                      [options]="dashboardChartConfig">
              </canvas>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col mb-4 stretch-card">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-3">{{'DASHBOARD.TOTAL_VISITORS_PER_WEEK' | translate }}</h4>
            <div class="chart-container">
              <canvas baseChart
                      [type]="charts[3].type"
                      [data]="charts[3].data"
                      [options]="dashboardChartConfig">
              </canvas>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col stretch-card">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-3">{{'DASHBOARD.TOTAL_VISITORS_PER_DAY' | translate }}</h4>
            <div class="chart-container">
              <canvas baseChart
                      [type]="charts[4].type"
                      [data]="charts[4].data"
                      [options]="dashboardChartConfig">
              </canvas>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
</ng-container>
